import wordsModule from "./wordsModule";
import canvasEvents from "./canvasEvents";
import utils from "./utils";
import imagesModule from "./imagesModule";
import presetHelper from "./presetHelper";
import textModule from "./textModule";
import textImageModule from "./textImageModule";
import kidsModule from "./kidsModule";
import { commonStyle } from "./canvasCommonStyle";

export default {
  ...wordsModule,
  ...canvasEvents,
  ...utils,
  ...imagesModule,
  ...presetHelper,
  ...textModule,
  ...textImageModule,
  ...kidsModule,
};

export { commonStyle };
